import React, { useEffect, useRef, useState } from "react";
import Modal from "@/components/Modal";
import { useTranslation } from "@/langs/useTranslation";
import { makeStyles } from "@material-ui/core/styles";
import "@/css/amap.scss";
import AMapLoader from "@amap/amap-jsapi-loader";
import axios from "axios";
import AutoComplete from "./Map/AutoComplete";
const useModalStyles = makeStyles(theme => ({
  StoreEditMapModal: {},
  StoreEditMapBox: {
    width: "100%",
    height: "100%",
    "& .map-search-input": {
      width: "88%"
    },
    "& .cancle-btn": {
      height: 38,
      width: 100
    },
    "& .platformMap": {
      height: 460
    },
    "& .map-detail": {
      background: "#F8F9FC",
      "border-radius": "10px",
      "margin-top": "16px",
      padding: "16px",
      display: "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "font-size": "14px",
      height: "60px",
      color: "#646473"
    }
  }
}));
// web js 配置
const AMapJsKey = "2897dee72b86514caabd9734f3dbc2ec";
const AMapJsCode = "743674811459d9382d9338327b62d88c";
// web 服务配置
const AMapWebServiceCode = "6fb9d2acb27a4601021d06ef0466cc27";
let map = null;
let marker = null;
let MapPlaceSearch = null;

function TranserModal({ open, onConfirm, onClose, addressData }) {
  const { t } = useTranslation();
  const [state, setState] = useState({
    latitude: "", // 纬度
    longitude: "", // 经度
    store_address: "",
    location_address: ""
    // adcode: "",
    // district: "",
    // address: "",
    // name: ""
  });

  const [AMap, setAmap] = useState(null);

  const [searchValue, setSearchValue] = useState("");

  const classes = useModalStyles();
  // 确定
  const handleConfirm = () => {
    return onConfirm(state);
  };

  useEffect(() => {
    setState({
      latitude: addressData.lat, // 纬度
      longitude: addressData.long, // 经度
      store_address: addressData.store_address
    });
    const latitude = addressData.lat ? addressData.lat : "31.217546";
    const longitude = addressData.long ? addressData.long : "121.360375";

    setTimeout(() => {
      const element = document.getElementById("platformMap");
      if (element) {
        window._AMapSecurityConfig = {
          securityJsCode: AMapJsCode
        };
        AMapLoader.load({
          key: AMapJsKey, // 申请好的Web端开发者Key，首次调用 load 时必填
          version: "2.0", // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
          plugins: [
            "AMap.Scale",
            "AMap.PlaceSearch",
            "AMap.AutoComplete",
            "AMap.LngLat"
          ] //需要使用的的插件列表，如比例尺'AMap.Scale'，支持添加多个如：['...','...']
        })
          .then(AMap => {
            setAmap(AMap);
            // var position = new AMap.LngLat(116, 39);//标准写法
            // var position = [116, 39]; //简写
            //创建一个 Marker 实例：
            map = new AMap.Map("platformMap", {
              // 设置地图容器id
              viewMode: "3D", // 是否为3D地图模式
              zoom: 11, // 初始化地图级别
              center: [longitude, latitude] // 初始化地图中心点位置
            });
            map.on("click", handleClickMap);
            marker = new AMap.Marker({
              position: new AMap.LngLat(longitude, latitude), //经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
              title: state.store_address
            });
            //将创建的点标记添加到已有的地图实例：
            map.add(marker);
            // marker 点击事件
            marker.on("click", function (e) {
              handleClickMap(e);
            });

            // 构造地图查询类
            MapPlaceSearch = new AMap.PlaceSearch({
              map: map,
              autoFitView: true
            }); //构造地点查询类
            // 搜索到的地图上的POI 信息点击
            AMap.Event.addListener(MapPlaceSearch, "markerClick", function (e) {
              handleClickMap(e.event);
            });

            //异步加载 AutoComplete 插件
            // var autoOptions = {
            //   input: "mapSearchInput"
            // };
            // //实例化AutoComplete
            // var autoComplete = new AMap.AutoComplete(autoOptions);
            // autoComplete.on("select", select);//注册监听，当选中某条记录时会触发
            // //根据关键字进行搜索 keyword 为搜索的关键词
            // autoComplete.search(searchValue, function (status, result) {
            //   //搜索成功时，result 即是对应的匹配数据
            //   console.log(result);
            // });
          })
          .catch(e => {
            console.log(e);
          });
      }
    });

    return () => {
      map?.destroy();
    };
  }, [addressData, open]);

  const handleClearPlaceSearch = () => {
    // 清空
    document.getElementById("mapSearchInput").value = "";
    MapPlaceSearch.clear();
  };

  function handleSelectFromAutoSrearch(e) {
    handleSelectOption(e);
    MapPlaceSearch.setCity(e.poi.adcode);
    MapPlaceSearch.search(e.poi.name); //关键字查询查询
  }

  const handleClickMap = async e => {
    const latitude = e.lnglat.lat; // 纬度
    const longitude = e.lnglat.lng; // 经度

    map.clearInfoWindow();

    const res = await axios.get("https://restapi.amap.com/v3/geocode/regeo", {
      params: {
        output: "json",
        location: longitude + "," + latitude,
        key: AMapWebServiceCode,
        radius: 1000,
        extensions: "all"
      }
    });
    if (res.status === 200 && res.data && res.data.status == 1) {
      const data = res.data;
      setState({
        ...state,
        latitude: latitude,
        longitude: longitude,
        store_address: data.regeocode.formatted_address
      });
      map.setCenter([longitude, latitude]);
      marker.setPosition([longitude, latitude]);
    }
  };

  const handleSelectOption = e => {
    setState({
      ...state,
      store_address: e.poi.district + e.poi.address + e.poi.name
    });
  };

  return (
    <Modal
      title={t({ defaultMessage: "选择地址" })}
      open={open}
      onClose={onClose}
      onConfirm={handleConfirm}
      className={classes.StoreEditMapModal}
      width={1000}
      height={600}
    >
      <div className={classes.StoreEditMapBox}>
        {/*<input className={`map-search-input`} id="mapSearchInput" placeholder={t({ defaultMessage: "搜索地址" })}/>*/}
        {/*<Button variant="outlined" color="#00a6be" className={`btn cancle-btn`} onClick={()=>handleClearPlaceSearch()}>*/}
        {/*  {t({defaultMessage: "清空"})}*/}
        {/*</Button>*/}
        <AutoComplete AMap={AMap} onSelect={handleSelectFromAutoSrearch} />

        <div className={`platformMap`} id={`platformMap`}></div>
        <div className={`map-detail`}>
          <div>
            {t({ defaultMessage: "详细地址" })}：{state.store_address}
          </div>
          <div>
            {t({ defaultMessage: "经纬度" })}：{state.longitude}
            {state.longitude && state.longitude.length > 0 ? "," : ""}
            {state.latitude}
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default React.memo(TranserModal);
